import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=499ed979&scoped=true"
import script from "./AddTemplate.vue?vue&type=script&lang=js"
export * from "./AddTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddTemplate.vue?vue&type=style&index=0&id=499ed979&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499ed979",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VRadio,VRadioGroup,VTextField,VTextarea})
